import mixpanel from 'mixpanel-browser';

mixpanel.init('1656db92f9043525afd655f1e15af1e4', {
    track_pageview: true,
    record_sessions_percent: 90,
    persistence: "localStorage",
});

export default mixpanel;
